import Vue from 'vue'
import router from './router'
import store from './store'
import oauth2 from './config/oauth2'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import qs from 'qs'
import note from './components/Message/index'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'expertLogin', 'expertApplyFor', 'oaLogin', 'portalLogin', 'oAuthCallback', 'oAuthCallbackLogin','loginByWeChat'] // no redirect whitelist

//登录名单
const LoginList = ['login', 'expertLogin','loginByWeChat']

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  // 先判断是否在白名单 内
  if (whiteList.includes(to.name)) {
    //记录什么登录方式
    if (LoginList.includes(to.name)) {
      window.localStorage.setItem('login', to.name)
    }
    // 在免登录白名单，直接进入
    next()
  } else {
    let LoginPath = window.localStorage.getItem('login') || '/login'
    // 不在白名单内，判断token
    if (Vue.ls.get(ACCESS_TOKEN)) {
      /* has token */
      if (LoginList.includes(to.name)) {
        next({ path: '/dashboard/workplace' })
        NProgress.done()
      } else {
        if (!store.getters.userInit) {
          store.dispatch('GetInfo').then(res => {
            let roles = {}
            if (res.code === 200) {
              let msgRefreshFlag = window.localStorage.getItem('msgRefresh')
              if (msgRefreshFlag && msgRefreshFlag === 'false') {
                note.init()
                window.localStorage.setItem('msgRefresh', 'true')
              }
              roles = res.result.user.permissions
            }
            const modules = res.result.module
            store.dispatch('GenerateRoutes', { roles, modules }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters)
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          }).catch(() => {
            store.dispatch('Logout').then(() => {
              next({ path: LoginPath, query: { redirect: to.fullPath } })
            })
          })
        } else {
          next()
        }
      }
    } else {
      next({ path: LoginPath, query: { redirect: to.fullPath } })
      NProgress.done()
    }
  }

})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    const elVal = vnode.context.$route.meta.permission
    const permissionId = elVal instanceof String && [elVal] || elVal
    roles.permissions.forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      if (p.actionList && !p.actionList.includes(actionName)) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    })
  }
})

export {
  action
}
